import React, { useEffect, useRef, useState } from "react";
import { getAdminActions } from "../../../config/actions";
import Top from "../Top";
import QuickActionsSidebar from "../DistributorDashboard/QuickActionsSidebar";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import "./Recordings.css";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));
const Recordings = () => {
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);

  const classes = useStyles();
  const navigation = useNavigate();
  const userType = localStorage.getItem("user_type");
  const handleUploadRecording = () => {
    navigation("/upload-recording");
  };
  const EditRecordingDistributor = () => {
    navigation("/edit-recording-distributor");
  };
  const UploadRecordingCustomer = () => {
    navigation("/upload-recording-customer");
  };
  const EditRecordingCustomer = () => {
    navigation("/edit-recording-customer");
  };


  return (
    <div className="recordings-container">
      <div className="recordings-dashboard">
        <QuickActionsSidebar actions={getAdminActions()} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />
        <div className="recordings-content">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="button-div">
              {(userType == 7 || userType == 8) && (
                <>
                  {" "}
                  <button
                    className="create-button"
                    onClick={handleUploadRecording}
                  >
                    Upload New Recording for Distributors
                  </button>
                  <button
                    className="create-button"
                    onClick={EditRecordingDistributor}
                  >
                    Edit Recordings for Distributors
                  </button>
                  <button
                    className="create-button"
                    onClick={UploadRecordingCustomer}
                  >
                    Upload New Recording for customers
                  </button>
                  <button
                    className="create-button"
                    onClick={EditRecordingCustomer}
                  >
                    Edit Recordings for customers
                  </button>
                </>
              )}
              {userType == 6 && (
                <>
                  <button
                    className="create-button"
                    onClick={UploadRecordingCustomer}
                  >
                    Upload New Recording for customers
                  </button>
                  <button
                    className="create-button"
                    onClick={EditRecordingCustomer}
                  >
                    Edit Recordings for customers
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Recordings;
